import { get, set } from 'lodash';

import { CompanyType, ENTITY_TYPE, FIELD_PATHS } from '@funnels/constants';
import { Asset, FormValuesPostProductSelect, PostProductSelectContract, RelatedParty } from '@funnels/types';

import { INITIAL_LICENSED_BUILDER_RELATED_PARTY } from './initialFormValues';

export function setLicensedBuilderRelatedPartyInitialValues(
  formValues: FormValuesPostProductSelect,
  applicationId: string
) {
  const postProductSelects = get(formValues, FIELD_PATHS.POST_PRODUCT_SELECTS(), []) as PostProductSelectContract[];
  const relatedParties = get(formValues, FIELD_PATHS.RELATED_PARTIES(), []) as RelatedParty[];
  const relatedPartiesToBeCreated: RelatedParty[] = [];
  postProductSelects
    .filter((pps) => pps.entityType === ENTITY_TYPE.LICENSED_BUILDER)
    .forEach((pps) => {
      const asset = formValues.assets.find((a) => a.clientId === pps.entityId);
      if (!asset) return;
      const hasLicensedBuilderRP = relatedParties.some(
        (rp) => rp.assetId === asset.clientId && rp.type === CompanyType.LicensedBuilder
      );
      if (!hasLicensedBuilderRP) {
        relatedPartiesToBeCreated.push(INITIAL_LICENSED_BUILDER_RELATED_PARTY(applicationId, asset.clientId));
      }
    });

  set(formValues, FIELD_PATHS.RELATED_PARTIES(), [...relatedParties, ...relatedPartiesToBeCreated]);
}
